import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { margin, styled } from "@mui/system";
import "../../index.scss";
import {
  TextField,
  MenuItem,
  Select,
  Button,
  Typography,
  Box,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import { getCategory } from "../../services/category.service";
import { createQrForm, filterObject } from "../../services/qr.service";
import { showToast } from "../../redux/Reducer/toastReducer";

import LogoPng from "../../assets/images/LoginPageLogo.png";
import { useNavigate } from "react-router-dom";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";

// Styled components for file upload
const FileUploadBox = styled(Box)({
  border: "2px dashed #00675d",
  padding: "10px",
  textAlign: "center",
  borderRadius: "6px",
  backgroundColor: "rgba(25, 208, 40, 0.1)",
  // "&:hover": { backgroundColor: "rgba(25, 208, 40, 0.1)" },
});

const CreateTicket = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [formData, setFormData] = useState({
    selectedCategory: "",
    categoryId: "",
    name: "",
    email: "",
    subject: "",
    message: "",
    isManagement: "false",
    file: null,
  });
  const [loading, setLoading] = useState(false);
  // const fileInputRef = React.useRef(null);
  const [fileName, setFileName] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFileName(file.name); // Set the file name
      setFormData((prevState) => ({ ...prevState, file: file }));
    }
  };

  // const handleFileChange = (event) => {
  //   setFormData((prevState) => ({ ...prevState, file: event.target.files[0] }));
  // };

  useEffect(() => {
    getCategory().then((res) => setCategory(res.data));
  }, []);

  const [emailError, setEmailError] = useState("");

  const emailRegex =
    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.(com|sg|in|org|net|edu|gov)$/;

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      if (!emailRegex.test(value)) {
        setEmailError("Please enter a valid email address.");
      } else {
        setEmailError("");
      }
    }
    if (name === "selectedCategory") {
      const selectedCategoryObj = category.find((ele) => ele.name === value);
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
        categoryId: selectedCategoryObj._id,
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };
  console.log("file upload: ", formData);
  const handleClearFile = () => {
    setFileName("");
    setFormData((prevState) => ({ ...prevState, file: null }));
    // if (fileInputRef.current) {
    //   fileInputRef.current.value = "";
    // }
  };
  const handleSubmit = async () => {
    if (
      formData.selectedCategory &&
      formData.name &&
      formData.email &&
      formData.subject &&
      formData.message &&
      !emailError
    ) {
      setLoading(true);
      const formDataToSend = new FormData();
      if (formData.file) formDataToSend.append("file", formData.file);
      let data = filterObject(formData, ["selectedCategory", "file"]);
      formDataToSend.append("values", JSON.stringify(data));

      try {
        const res = await createQrForm(formDataToSend);
        dispatch(
          showToast({
            message: res.message,
            type: res.error ? "error" : "success",
          })
        );
        if (!res.error)
          setFormData({
            selectedCategory: "",
            categoryId: "",
            name: "",
            email: "",
            subject: "",
            message: "",
            isManagement: "false",
            file: null,
          });
        navigate("/qrFormSubmit");
      } catch {
        dispatch(showToast({ message: "Submission error", type: "error" }));
      } finally {
        setLoading(false);
      }
    } else {
      dispatch(
        showToast({ message: "Please Enter all fields", type: "error" })
      );
    }
  };

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", p: 3 }}>
      <Box sx={{ textAlign: "center" }}>
        <img
          src={LogoPng}
          alt="My PNG"
          style={{ width: "100%", maxWidth: "100px" }}
        />
      </Box>
      <Typography variant="h5" align="center" gutterBottom>
        FEEDBACK FORM
      </Typography>
      <Typography className="formInputLabel" align="center">
        Complete the form to raise a ticket, and we’ll address your concerns
        efficiently.
      </Typography>

      <Grid container spacing={2} sx={{ marginTop: "50px" }}>
        <Grid item size={12}>
          <Typography className="formInputLabel">
            Category <span style={{ color: "red" }}>*</span>
          </Typography>
          <Select
            fullWidth
            name="selectedCategory"
            value={formData.selectedCategory}
            onChange={handleChange}
            displayEmpty
            required
          >
            <MenuItem value="" disabled>
              Select category
            </MenuItem>
            {category.map((ele, index) => (
              <MenuItem key={index} value={ele.name}>
                {ele.name}
              </MenuItem>
            ))}
          </Select>
        </Grid>
        <Grid item size={12}>
          <Typography className="formInputLabel">
            Name <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter Your Name"
            name="name"
            value={formData.name}
            onChange={handleChange}
          />
        </Grid>

        <Grid item size={12}>
          <Typography className="formInputLabel">
            Email <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter Your Email"
            name="email"
            value={formData.email}
            onChange={handleChange}
          />
          {emailError && (
            <span style={{ color: "red", fontSize: "14px" }}>{emailError}</span>
          )}
        </Grid>

        <Grid item size={12}>
          <Typography className="formInputLabel">
            Subject <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            placeholder="Enter Subject"
            name="subject"
            value={formData.subject}
            onChange={handleChange}
          />
        </Grid>

        <Grid item size={12}>
          <Typography className="formInputLabel">
            Message <span style={{ color: "red" }}>*</span>
          </Typography>
          <TextField
            fullWidth
            placeholder="  Write Your Message Here..."
            name="message"
            value={formData.message}
            onChange={handleChange}
            multiline
            rows={4}
          />
        </Grid>

        <Grid item size={12}>
          <FormControl component="fieldset">
            <Typography className="formInputLabel">
              Would you like to send it to Higher Authority{" "}
              <span style={{ color: "red" }}>*</span>
            </Typography>
            <RadioGroup
              name="isManagement"
              value={formData.isManagement}
              onChange={handleChange}
              row
            >
              <FormControlLabel
                value="true"
                control={<Radio sx={{ "&.Mui-checked": { color: "green" } }} />}
                label="Yes, send it to Higher Authority"
              />
              <FormControlLabel
                value="false"
                control={<Radio sx={{ "&.Mui-checked": { color: "green" } }} />}
                label="No, don't send it to Higher Authority"
              />
            </RadioGroup>
          </FormControl>
        </Grid>

        <Grid item size={12}>
          <Typography className="formInputLabel">File Upload</Typography>

          <FileUploadBox>
            <Stack
              direction="row"
              spacing={2}
              sx={{
                justifyContent: formData?.file ? "space-between" : "center",
                alignItems: "center",
              }}
            >
              <label htmlFor="file-upload">
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <UploadFileIcon sx={{ color: "#00675d" }} />
                  <Typography variant="body2">
                    {fileName ? fileName : <span>Upload your file here</span>}
                  </Typography>
                  <input
                    type="file"
                    id="file-upload"
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                    // ref={fileInputRef}
                  />
                </Stack>
              </label>

              {formData.file && (
                <Button onClick={handleClearFile}>
                  <ClearOutlinedIcon />
                </Button>
              )}
            </Stack>
          </FileUploadBox>
        </Grid>
        <Grid item size={12}>
          <Stack
            direction="row"
            spacing={2}
            sx={{
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Button
              variant="contained"
              size="small"
              className="addButton"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Submitting..." : "Save"}
            </Button>
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default CreateTicket;
